module.exports = __webpack_public_path__ + "img/31.4fd74c47.png";